import React from 'react';
import PropTypes from 'prop-types';

const TextInputValidate = ({value, label, inputType, placeholder, property, error, onChange, wrapClass, isRequired = false}) => {
  wrapClass = wrapClass ? wrapClass : 'col-md-6 col-xs-12';
  return (
    <div className={wrapClass}>
      <div className="form-group">
        <div className="col-md-4 col-xs-12 text no-padding-left">
          <p>{label}</p> {isRequired && <span className = "color-red"> *</span>}
        </div>
        <div className="col-md-8 col-xs-12 value no-padding-right">
          <input type={inputType || 'text'} className="form-control" placeholder={placeholder}
                 value={value}
                 onChange={evt => onChange(property, evt.target.value)} />
          {error && <div className="alert-warning">{error}</div>}
        </div>
      </div>
    </div>
  );
}

TextInputValidate.propTypes = {
  label: PropTypes.string.isRequired,
  inputType: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  property: PropTypes.string.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  wrapClass: PropTypes.string
};

export default TextInputValidate;